import React, { FC, useEffect } from 'react';
import useScrollToSection from '@hooks/useScrollToSection';
import useTranslations from '@hooks/useTranslation';
import Title, { TitleTagTypes } from '@ui/SectionTitle/Title';
import ContentTemplate from '../../ui/Content/Content';
import TeamPersonTemplate from '../../ui/TeamPerson/TeamPerson';
import { Persons } from './Team.elements';

export interface TeamProps {}

export const TEAMS = [
    {
        image: '/team_person2.webp',
        name: 'Miroslav Růžička',
        position: 'Jednatel Studio W',
        phones: [] as string[],
        mail: '',
    },
    {
        image: '/team_person9.webp',
        name: 'Vanesa Rajchartová',
        position: 'Produktová manažerka – mzdy, pracovní právo, personalistika a veřejná správa. Učebny',
        phones: ['+420 734 156 851'] as string[],
        mail: 'rajchartova@pp.cz',
    },
    {
        image: '/team_person11.jpg',
        name: 'Gabriela Polívková',
        position: 'Produktová manažerka - daně, účetnictví a finance',
        phones: ['+420 602 245 664'] as string[],
        mail: 'polivkova@pp.cz',
    },
    {
        image: '/team_person6.webp',
        name: 'Šárka Jurečková',
        position: 'Produktová manažerka - soft skills, firemní kurzy na míru',
        phones: ['+420 602 398 155'] as string[],
        mail: 'jureckova@pp.cz',
    },
    {
        image: '/team_person12.jpg',
        name: 'Veronika Ábelová',
        position: 'Marketing, mediální spolupráce',
        phones: ['+420 737 936 574'] as string[],
        mail: 'abelova@pp.cz',
    },
    {
        image: '/team_person13.jpg',
        name: 'Miluše Blahutová',
        position: 'Vedoucí call centra',
        phones: ['+420 212 247 811'] as string[],
        mail: 'blahutova@pp.cz',
    },
    {
        image: '/team_person14.jpg',
        name: 'Gabriela Košutová',
        position: 'Call centrum',
        phones: ['+420 212 247 811'] as string[],
        mail: 'kosutova@pp.cz',
    },
    {
        image: '/team_person15.jpg',
        name: 'Elizabeth Salimová',
        position: 'Specialistka klientské péče',
        phones: ['+420 212 247 824'] as string[],
        mail: 'salimova@pp.cz',
    },
    {
        image: '/team_person3.webp',
        name: 'Lucie Grygerová',
        position: 'Obchodní zástupkyně, otevřené a firemní kurzy, roční předplatné',
        phones: ['+420 793 984 016'] as string[],
        mail: 'grygerova@pp.cz',
    },
];

const TeamTemplate: FC<TeamProps> = () => {
    const { t } = useTranslations();

    useScrollToSection('nas-tym', 'nastym');

    return (
        <ContentTemplate withPadding id="nastym" mobileSidePadding={20}>
            <Title tagType={TitleTagTypes.H3} isBlack>
                {t('contact.team.title')}
            </Title>
            <Persons>
                {TEAMS.map((person, personKey) => (
                    <TeamPersonTemplate
                        key={personKey}
                        personKey={personKey}
                        image={person.image}
                        name={person.name}
                        position={person.position}
                        phones={person.phones}
                        mail={person.mail}
                    />
                ))}
            </Persons>
        </ContentTemplate>
    );
};

export default TeamTemplate;
